// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type { TApiTransport } from '#request/request.types.ts';
import { createGeV2Api } from '#ge-v2/ge-v2.api.ts';
import { createTermsApi } from '#terms/terms.api.ts';
import { createAclsApi } from '#acls/acls.api.ts';
import { createDependentsApi } from '#dependents/dependents.api.ts';
import { createBotApi } from '#bot/bot.api.ts';
import { createKbSyncApi } from '#kb-sync/kb-sync.api.ts';
import { createGeBuilderApi } from '#ge-builder/ge-builder.api.ts';
import { createApiKeysApi } from '#api-keys/api-keys.api.ts';
import { createAssistantSettingsApi } from '#assistant-settings/assistant-settings.api.ts';
import { createIntegrationsApi } from '#integrations/integrations.api.ts';
import { createAuthApi } from '#auth/auth.api.ts';
import { createPluginsApi } from '#plugins/plugins.api.ts';
import { createTicketingApi } from '#ticketing/ticketing.api.ts';
import { createPromptsApi } from '#prompts/prompts.api.ts';
import { createTicketingIntegrationsApi } from '#ticketing-integrations/ticketing-integrations.api.ts';
import { createConversationFilesApi } from '#conversation-files/conversation-files.api.ts';
import { createConversationsApi } from '#conversations/conversations.api.ts';
import { createDocumentNavigatorApi } from '#document-navigator/document-navigator.api.ts';
import { createPortalAgentApi } from '#portal-agent/portal-agent.api.ts';
import { createUserApi } from '#user/user.api.ts';
import { createScope1Api } from '#scope1/scope1.api.ts';
import { createLlmApi } from '#llm/llm.api.ts';
import { createMetricsApi } from '#metrics/metrics.api.ts';
import { createProjectSettingsApi } from '#project-settings/project-settings.api.ts';
import { createDocumentSuggestionsApi } from '#document-suggestions/document-suggestions.api.ts';
import { createHrisTaggingApi } from '#hris-tagging/hris-tagging.api.ts';
import { createNotificationsApi } from '#notifications/notifications.api.ts';
import { createReductoWebhookApi } from '#reducto-webhook/reducto-webhook.api.ts';
import { createTaggingApi } from '#tagging/tagging.api.ts';

export const createCascadeApi = (transport: TApiTransport) => ({
  geV2: createGeV2Api(transport),
  terms: createTermsApi(transport),
  acls: createAclsApi(transport),
  dependents: createDependentsApi(transport),
  bot: createBotApi(transport),
  kbSync: createKbSyncApi(transport),
  geBuilder: createGeBuilderApi(transport),
  apiKeys: createApiKeysApi(transport),
  assistantSettings: createAssistantSettingsApi(transport),
  integrations: createIntegrationsApi(transport),
  auth: createAuthApi(transport),
  plugins: createPluginsApi(transport),
  ticketing: createTicketingApi(transport),
  prompts: createPromptsApi(transport),
  ticketingIntegrations: createTicketingIntegrationsApi(transport),
  conversationFiles: createConversationFilesApi(transport),
  conversations: createConversationsApi(transport),
  documentNavigator: createDocumentNavigatorApi(transport),
  portalAgent: createPortalAgentApi(transport),
  user: createUserApi(transport),
  scope1: createScope1Api(transport),
  llm: createLlmApi(transport),
  metrics: createMetricsApi(transport),
  projectSettings: createProjectSettingsApi(transport),
  documentSuggestions: createDocumentSuggestionsApi(transport),
  hrisTagging: createHrisTaggingApi(transport),
  notifications: createNotificationsApi(transport),
  reductoWebhook: createReductoWebhookApi(transport),
  tagging: createTaggingApi(transport),
});
